<script>
import {
  modeCommandeOverviewEmits,
  modeCommandeOverviewProps,
  useModeCommandeOverview
} from "./mixin";
import LazyImage from "@/components/atoms/lazy-image";
import Titre from "@/components/atoms/titre";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";

export default {
  name: "ModeCommandeOverview",
  components: {
    LazyImage,
    Titre,
    Badge,
    Button
  },
  props: {
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    },
    ...modeCommandeOverviewProps()
  },
  emits: [...modeCommandeOverviewEmits()],
  setup(props, context) {
    const {
      image,
      titre,
      accroche,
      premierCreneau,
      cta,
      tarif,
      ctaAction,
      actionSecondaire
    } = useModeCommandeOverview(props, context);

    return {
      image,
      titre,
      accroche,
      premierCreneau,
      cta,
      tarif,
      ctaAction,
      actionSecondaire
    };
  }
};
</script>

<template>
  <div
    class="c-mode-commande-overview u-text-center"
    :class="horizontal && 'c-mode-commande-overview--horizontal u-pr-md'"
  >
    <div class="c-mode-commande-overview__top">
      <LazyImage
        :src="image"
        :width="horizontal ? 110 : 139"
        height="60"
        class="c-mode-commande-overview__image"
      />
      <div :class="horizontal && 'u-text-left'">
        <div :class="!horizontal ? 'u-mb-sm' : ''">
          <Titre
            tag="h3"
            variant="primary"
            size="xs"
            :class="horizontal ? 'u-mb-xxs' : 'c-mode-commande-overview__title'"
          >
            {{ titre }}
          </Titre>
          <p
            v-if="horizontal"
            class="c-mode-commande-overview__accroche u-font-14"
            :class="horizontal ? 'u-text-left u-mb-xxs u-mr-md' : 'u-mt-sm'"
          >
            {{ accroche }}
          </p>
        </div>
        <Button
          v-if="horizontal && (modeCommande.type === 'CEV' || modeCommande.type === 'PRC' || modeCommande.type === 'PRC_DELIPOP')"
          link
          @click="actionSecondaire"
        >
          En savoir plus
        </Button>
      </div>
    </div>
    <div class="c-mode-commande-overview__bottom">
      <Badge
        outline="green-alt"
        radius="md"
        class="u-py-xs u-px-sm"
        :class="horizontal ? 'u-mr-xlg u-mr-md@sm u-ml-auto' : 'u-mb-sm'"
      >
        {{ premierCreneau }}
      </Badge>
      <p
        v-if="modeCommande.type !== 'LAD'"
        :class="horizontal ? 'u-mr-xlg u-mr-md@sm' : 'u-mb-sm c-mode-commande-overview-buttontarif'"
      >
        {{ tarif }}
      </p>
      <div v-else>
        <Button
          link
          :class="horizontal ? 'u-mr-xlg u-mr-md@sm' : 'u-mb-sm c-mode-commande-overview-buttontarif'"
          @click="actionSecondaire"
        >
          Voir les tarifs
        </Button>
      </div>
      <Button
        radius="full"
        variant="primary"
        size="sm"
        class="c-mode-commande-overview-buttoncta"
        @click="ctaAction"
      >
        {{ cta }}
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-mode-commande-overview {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}
.c-mode-commande-overview__title {
  min-height: 5.6rem;
}

.c-mode-commande-overview__accroche {
  min-height: 3.5rem;
}

.c-mode-commande-overview-buttoncta {
  padding: 0.6rem 2.4rem;
}
.c-mode-commande-overview-buttontarif {
  min-height: 2.4rem;
}

.c-mode-commande-overview--horizontal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: auto;
  .c-mode-commande-overview__accroche {
    min-height: 0;
  }
  .c-mode-commande-overview__top {
    display: flex;
    align-items: center;
  }
  .c-mode-commande-overview__bottom {
    display: flex;
    align-items: center;
  }
}
</style>
